import { SVGProps } from 'react';

const Maintenance = ({
  props,
  fill = 'currentColor',
  size = 24,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill={fill}
      d="M18.781 18.5a1.25 1.25 0 0 0-1.126-1.244l-.124-.006a1.25 1.25 0 1 0 1.25 1.25ZM11 14.25a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1 0-1.5h3ZM17.25 12V7a1.25 1.25 0 0 0-1.126-1.244L16 5.75h-1.356a2.748 2.748 0 0 1-2.644 2h-2a2.75 2.75 0 0 1-2.644-2H6A1.25 1.25 0 0 0 4.75 7v12l.006.124A1.25 1.25 0 0 0 6 20.25h5.697a.75.75 0 0 1 0 1.5H6A2.75 2.75 0 0 1 3.25 19V7A2.75 2.75 0 0 1 6 4.25h1.356a2.747 2.747 0 0 1 2.644-2h2a2.75 2.75 0 0 1 2.644 2H16A2.75 2.75 0 0 1 18.75 7v5a.75.75 0 0 1-1.5 0ZM12 10.25a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1 0-1.5h4Zm-2-6.5a1.25 1.25 0 0 0 0 2.5h2l.124-.006a1.25 1.25 0 0 0 0-2.488L12 3.75h-2ZM20.281 18.5c0 .229-.033.454-.088.672l.743.429a.75.75 0 1 1-.75 1.298l-.74-.427c-.33.32-.73.547-1.165.67V22a.75.75 0 1 1-1.5 0v-.857a2.745 2.745 0 0 1-1.165-.672l-.741.428a.75.75 0 0 1-.75-1.298l.743-.43a2.745 2.745 0 0 1-.087-.671c0-.229.032-.454.087-.672l-.743-.429a.75.75 0 0 1 .75-1.298l.741.427c.33-.32.73-.548 1.165-.672V15a.75.75 0 0 1 1.5 0v.856c.434.124.834.352 1.163.671l.742-.426a.75.75 0 0 1 .75 1.298l-.743.428c.056.219.088.444.088.673Z"
    />
  </svg>
);

export default Maintenance;
